export default "__VITE_ASSET__UWcyaOs9__"